import { useQuery } from "@tanstack/react-query";
import moment from "moment-timezone";
import { useFilters } from "../../../../utils/hooks/useFilters";
import useApi from "../../../../utils/api";

export const useHolidays = () => {
    const { authGet } = useApi();
    const [filters] = useFilters();

    const query = useQuery({
        queryKey: ["/holiday/date", {
            startDate: filters?.mode === "month"
                ? moment(filters?.from).startOf("week").format("YYYY-MM-DD")
                : filters?.from,
            endDate: filters?.mode === "month"
                ? moment(filters?.to).endOf("week").format("YYYY-MM-DD")
                : filters?.to
        }],
        queryFn: ({ queryKey }: any) => {
            const [url, params] = queryKey;
            return authGet(url, { params });
        }
    });

    return { data: query.data || [] }
}